// Vendor JS
import Debug from 'debug';

// Custom JS
import toc from '../common/toc';
import CigNotify from '../common/notification';
import Comments from '../common/comments/comments';

/* eslint-disable no-new */

/**
 * This runs on Single Posts and Pages
 */
export default {

	/* JavaScript to be fired on the home page */
	init() {
		try {
			Debug(`cig:info:sage:route:single`)(`init start`);

			// [What do I do?]
			toc.init();

			// Flag the post as seen immediately (removing it from the alerts bar)
			CigNotify.flagPostRead();

			// Comment Barrel (sort of) Comment Actions, Comment Admin, Comment Reply Notifications
			new Comments();

		} catch (err) {
			Debug(`cig:error:sage:route:single`)(`Single Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:single`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:single`)(`Single Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
};
